<template>
    <div>
        <my-header @userInfo="getuserInfo" :logotag="1"></my-header>
        <div class="bhsection">
            <h1>做电子保函查验的领导者</h1>
            <div class="bhsearch">            
                <div class="form">
                    <div>
                        <!-- <el-select v-model="bhtype" placeholder="请选择保函类型" @change="setbhlx" style="width:26.3%;">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select> -->
                        <el-input v-model="form.guaranteecode" placeholder="请输入保函编号" @focus="isuserInfo()"  style="width:36%;"></el-input>
                        <el-input v-model="form.querycode" placeholder="请输入备案码" @focus="isuserInfo()" style="width:63%;"></el-input>
                    </div>
                    <el-collapse-transition>
                        <div v-if="islogin" class="mobile">
                            <el-input v-model="yzmform.extmobile" placeholder="请输入手机号"  style="width:70%;">
                                <el-button 
                                    slot="append" 
                                    type="text"
                                    :loading="loadingController" 
                                    :disabled="inputDisabled"                              
                                    @click="getyzm()"
                                    >                           
                                    {{text}}
                                </el-button>
                            </el-input>                   
                            <el-input v-model="yzmform.validate" placeholder="请输入验证码" style="width:29%;"></el-input>
                        </div>
                    </el-collapse-transition>
                    <div class="btn" @click="search()">
                        查询
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="保险公司选择" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false" :before-close="handleClose">
            <ul class="bxgs">
                <li><a @click="zhdialog=true">中华联合财产保险股份有限公司</a></li>
                <li><a href="https://www.95505.com.cn/customer_service/electronic_policy.html" target="_blank">天安财产保险股份有限公司河北省分公司</a></li>
            </ul>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="zhdialog" width="60%" :close-on-click-modal="false">
            <div class="zhdialog">
                <h3>请选择其他险->其他非车险进行查验</h3>
                <img src="@images/bhqueryYd.png" alt="" style="width:900px;margin:0 auto;" />
                <div style="width:100%;text-align:center;">
                    <el-button type="warning" @click="gozh()">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    head: {
        title: '保函验证'
    },
    data: () => ({
        zhdialog:false,
        islogin:false,
        userInfo:'',
        text:'发送验证码',
        dialogVisible:false,
        loadingController:false,
        inputDisabled:false,
        bhtype:'1',    
        options:[
            {label:'电子担保保函',value:'1'},
            {label:'电子保险保函',value:'2'}
        ],
        mobile:'',
        yzm:'',
        form:{
            guaranteecode:'',
            querycode:''
        },
        yzmform:{
            extmobile:'',
            validate:'',
            extloginname:'',
            extpwd:'',
        },
    }),
    methods: {
        ...mapMutations({
            updateUserInfo: 'userinfo/updateUserInfo',
        }),

        gozh(){
            window.open("http://query.cic.cn/autoclaim/epiq/main.jsp");
        },
        isuserInfo(){
            console.log('this.userInfo' , this.userInfo);
            if(this.userInfo==='1'){
                this.islogin=true;
            }
        },
        getuserInfo(data){
            this.userInfo=data;
        },
        handleClose(){
            if(this.bhtype==='2'){
                ShowConfirm('该类型必须选择保险公司，确认关闭吗','warning',()=>{
                    this.dialogVisible=false;
                    this.bhtype='1';
                })              
            }          
        },
        setbhlx(code){
            if(code==='2'){
                this.dialogVisible=true;
            }
        },
        search(){
            var that = this;
            if(this.form.guaranteecode===''||this.form.querycode===''){
                ShowMsg('请输入保函编号或备案码')
            }else {
                // 显示 手机号 验证码
                if(this.islogin){
                    this.$post(`${this.$store.state.api.sysUrl}/user/phonelogin.json`,this.yzmform, function (data, res) {

                        that.updateUserInfo(data);
                        that.goto({
                            path: '/guarantee/bh',
                            query: {
                                guaranteecode: this.form.guaranteecode,
                                querycode: this.form.querycode,
                                phonenum: this.yzmform.extmobile,
                                validatecode: this.yzmform.validate
                            }
                        });
                    });
                } else{

                    // 已登录
                    this.goto({
                        path: '/guarantee/bh',
                        query: {
                            guaranteecode: this.form.guaranteecode,
                            querycode: this.form.querycode,
                            phonenum: this.yzmform.extmobile,
                            validatecode: this.yzmform.validate
                        }
                    });

                }
                


                // this.goto({
                //     path: '/guarantee/bh',
                //     query: {
                //         guaranteecode: this.form.guaranteecode,
                //         querycode: this.form. querycode,
                //         phonenum:this.yzmform.extmobile,
                //         validatecode: this.yzmform.validate    
                //     }
                // });
            } 
        },
        getyzm(){
            if(!this.yzmform.extmobile ||  !/^[1][0-9]{10}$/.test(this.yzmform.extmobile)) {
                ShowMsg('请确认手机号', 'warning');
                return;
            };
            this.$post(`${this.$store.state.api.sysUrl}/user/sendyzm.json`, {
                phonenum: this.yzmform.extmobile
            }, data => {
                //倒计时
                this.loadingController = true;
                this.inputDisabled = true
                //倒计时
                var remain = 60;
                this.text = '请在' + remain + 's后重试'

                var int = setInterval(() => {
                    if (remain != 0) {
                        remain--
                        this.text = '请在' + remain + 's后重试'
                    } else {
                        clearInterval(int);
                        this.text = '获取手机验证码';
                        this.inputDisabled = false;
                        this.loadingController = false;
                    }
                }, 1000)

            })
        }
    },
    created() {
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    $spaceHeight: 28px;

    .header{
        background-image: url(~@images/guarantee/banner.jpg);      
    }
    .bhsection{
        width: 100%;
        min-height:592px;
        background-image: url(~@images/guarantee/banner1.jpg);
        padding:110px 0 150px;
        h1{
            width: 308px;
            height: 37px;
            margin:0 auto;
            font-size: 28px;
            color: #ffffff;
        }
        ::v-deep .el-input__inner {
            line-height: 58px;
            height: 58px;
            font-size: 14px;
        }

        ::v-deep .el-input-group__append{
            button.el-button{
                padding: 0 10px;
                font-size: 14px;
                &:hover{
                    opacity: 0.8;
                }
            }
        }
        .login{
            cursor: pointer;
            width:100px;
            color:#ffb73b;
            line-height: 58px;
            height: 58px;
            text-align: center;
            border:1px solid #DCDFE6;
            border-radius: 4px;
            float: right;
            &:hover{
                background:#ffb73b;
                color:#ffffff;
            }
        }
        .bhsearch{
            width: 760px;
            background-color: #ffffff;
            border-radius: 4px;
            width:760px;
            margin:0 auto;
            margin-top:40px;
            padding: 48px;
            box-shadow: 0px 3px 12px 0px rgba(158, 170, 203, 0.06);
            .form{
                width:630px;              
                margin:0 auto;
                .mobile{
                    margin-top: $spaceHeight;
                }

                .btn{
                    width:100%;
                    height:66px;
                    line-height:66px;
                    text-align: center;
                    color:#ffffff;
                    font-size: 22px;
                    background-color: #ffb73b;
                    margin:0 auto;
                    margin-top: $spaceHeight;
                    cursor: pointer;
                }
            }

        }
    }

    .products {
        text-align: center;
        img{
            width: 1190px;
            box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.1);
        }
    }
    .bxgs{
        width: 80%;
        height:100px;
        margin:0 auto;
        display: flex;
        justify-content: space-between;
        li{
            width: 40%;
            height:40px;
            line-height:40px;
            text-align: center;
            border:1px solid #ffb73b;
            a{
                width: 100%;
                height:100%;
                display: block;
                color:#ffb73b;
            }
            a:hover{
                background:#ffb73b;
                color:#ffffff;
            }
        }
    }
    .zhdialog{
        text-align: center;
        h3{
            margin-bottom:10px;
        }
    }
</style>
